"use client";

import type { Metadata } from "next";
import { useSearchParams } from "next/navigation";
import { PropsWithChildren, Suspense, useEffect, useState } from "react";

import { useOnboardingStore } from "@/stores";
import Logo from "@/svgs/haute-societe.svg";
import { animatePageIn } from "@/utils";

import styles from "./template.module.scss";

export const metadata: Metadata = {
  title: "...",
};

const banners = [1, 2, 3, 4];

//TODO:: uncomment everything to turn on referrerCode in signup flow
const RootTemplate = ({ children }: PropsWithChildren) => {
  const [splashScreenOpened, setSplashScreenOpened] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setSplashScreenOpened(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (!splashScreenOpened) {
      animatePageIn();
    }
  }, [splashScreenOpened]);

  return (
    <Suspense fallback={"Loading..."}>
      <Suspense fallback={null}>
        <InitializeReferrerCode />
      </Suspense>
      {splashScreenOpened ? (
        <div className={styles.splashScreen}>
          <Logo className={styles.icon} />
        </div>
      ) : (
        banners.map((index) => (
          <div key={index} id={`banner-${index}`} className={`${styles.banner} ${styles[`banner-${index}`]}`} />
        ))
      )}
      {!splashScreenOpened && children}
    </Suspense>
  );
};

const InitializeReferrerCode = () => {
  const setReferralCode = useOnboardingStore((state) => state.actions.setReferralCode);

  const searchParams = useSearchParams();
  const referralCode = searchParams.get("referralCode");

  useEffect(() => {
    if (referralCode) {
      setReferralCode(referralCode);
    }
  }, [referralCode]);

  return null;
};

export default RootTemplate;
